import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import "react-toastify/dist/ReactToastify.css";

import Map from "./components/Map/Map";

/* eslint-disable-next-line */
import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";

/* eslint-disable-next-line */
let activeCategories = ["ST", "G", "N", "C", "P"];
/* eslint-disable-next-line */
const searchValue = "";

const App = () => {
  const [state, setState] = useState({
    coordinateData: [] as any[],
    loading: true,
    error: null,
    siteUrl: ''
  });

  useEffect(() => {
    // parse the site url without any index.html
    const { origin, pathname } = window.location;
    let actualPath = pathname;
    if (pathname.endsWith('/index.html')) {
      actualPath = pathname.slice(0, -11);
    } else if (pathname.endsWith('/')) {
      actualPath = pathname.slice(0, -1);
    }
    const siteUrl = `${origin}${actualPath}`;
    // console.log(siteUrl);

    const loadData = async () => {
      try {
        // const datafile = window.location.host === 'fpdsites.gsfc.nasa.gov' ? 'data.txt' : 'data.json';
        const datafile = 'data.json';
        const response = await fetch(`${siteUrl}/data/${datafile}`);
        if (!response.ok) {
          const err = `Failed to load data: ${response.status} - ${response.statusText}`;
          console.error(err);
          throw new Error(err);
        } else {
          const data = await response.json();
          // default to full data set
          let coordinateData: any[] = data;
          if (origin.toLowerCase().includes('messier') || pathname.toLowerCase().includes('messier')) {
            // pull only messier objects
            coordinateData = data.filter((el: any) => el.cm_id.startsWith('M'));
          } else if (origin.toLowerCase().includes('caldwell') || pathname.toLowerCase().includes('caldwell')) {
            // pull only caldwell objects
            coordinateData = data.filter((el: any) => el.cm_id.startsWith('C'));
          }

          setState({
            coordinateData,
            loading: false,
            error: null,
            siteUrl
          });
        }
      } catch (err: any) {
        setState({
          coordinateData: [],
          loading: false,
          error: err.message,
          siteUrl
        });
      }
    }

    loadData();
  }, []);

  const { coordinateData, loading, error, siteUrl } = state;

  return (
    <div className="App">
      <Map
        activeCategories={activeCategories}
        ObjectCoordinates={coordinateData}
        isLoading={loading}
        error={error}
        siteUrl={siteUrl}
      />
      <ToastContainer autoClose={2000} position="bottom-right" hideProgressBar={true} />

    </div>
  );
};

export default App;
